// extracted by mini-css-extract-plugin
module.exports = {"RegisterForm":"RegisterForm_RegisterForm__Ky5qV","Error":"RegisterForm_Error__gN27p","Message":"RegisterForm_Message__drQPv","Checkbox":"RegisterForm_Checkbox__bPLu5"};